import clsx from "clsx";

import styles from "./link-button.module.scss";

const LinkButton = ({
  className,
  outline,
  rounded,
  small,
  mini,
  dark,
  clear,
  children,
  ...props
}) => {
  return (
    <a
      className={clsx(
        styles.Button,
        outline && styles.Outline,
        rounded && styles.Rounded,
        small && styles.Small,
        mini && styles.Mini,
        dark && styles.Dark,
        clear && styles.Clear,
        className
      )}
      {...props}
    >
      {children}
    </a>
  );
};

export default LinkButton;
